import { useTranslation } from 'react-i18next';
import { Container } from '@beyond-silence/ui';

/**
 * Staff 404 page.
 */
export function NotFoundPage() {
  const { t } = useTranslation('common');

  return (
    <Container size="article" className="flex min-h-[40vh] flex-col items-center justify-center py-8 text-center">
      <span className="font-ui text-[60px] font-bold leading-none text-primary/20 md:text-[80px]">
        404
      </span>
      <h1 className="mt-2 font-ui text-ui-lg font-semibold text-ink">
        {t('states.notFound')}
      </h1>
      <a
        href="/dashboard"
        className="mt-4 inline-block rounded-pill bg-primary px-4 py-2 font-ui text-ui-sm font-medium text-white hover:bg-primary-600"
      >
        {t('actions.backToHome')}
      </a>
    </Container>
  );
}
